<template>
    <svg viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 0.844849L5 4.84485L9 0.844849" stroke-width="2"/>
    </svg>
</template>

<script>
export default {
    name: "ChevronDown"
};
</script>